import { takeLatest } from "redux-saga/effects";
import { emailPostRequestSaga, firebaseInitializeSaga } from "./saga";
import {
  FIREBASE_SIGNIN_PWD_REQUEST,
  GET_SIGNIN_EMAIL_REQUEST,
} from "../consts";

export default function* watchSignin() {
  yield takeLatest(GET_SIGNIN_EMAIL_REQUEST, emailPostRequestSaga);
  yield takeLatest(FIREBASE_SIGNIN_PWD_REQUEST, firebaseInitializeSaga);
}
